import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "../Menu";
import { InputNumber } from "primereact/inputnumber";
import { jsPDF } from "jspdf";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { InputMask } from "primereact/inputmask";

export default function ProcesosPercepciones(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [visibleProceso, setVisibleProceso] = useState(true);
  const [todosLosCobradores, setTodosLosCobradores] = useState(false);
  const [repetirPeriodo, setRepetirPeriodo] = useState(false);
  const [proceso, guardarProceso] = useState(null);
  const [valor, guardarValor] = useState("cuota");
  const [fijo, setFijo] = useState(null);
  const toast = useRef(null);
  const acCobrador = useRef(null);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    cobradores,
    statusAcceso,
    empresaElegida,
    listadoExcel,
    empresas,
    configuracion,
    obtenerAcceso,
    tiposComprobantes,
    procesos,
    obtenerModulos,
    obtenerCobradores,
    obtenerEmpresas,
    procesoPercepcionesAGIP,
    obtenerTiposComprobantes,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ProcesosPercepciones",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerEmpresas();
  }, []);

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideProceso = (e) => {
    setVisibleProceso(false);
  };

  const aceptarProceso = async (e) => {
    e.preventDefault();
    //Validar

    if (
      !proceso ||
      proceso.periodo === undefined ||
      proceso.periodo === null ||
      proceso.periodo === 0 ||
      proceso.periodo === ""
    ) {
      mensajeAlerta("Percepciones", "El período es necesario !.", "error");
      return;
    }
    confirm1();
  };

  const confirm1 = () => {
    confirmDialog({
      message: "Esta seguro de iniciar el proceso de exportación",
      header: "Confirmación",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-success",
      closable: false,
      acceptLabel: "Si",
      accept: accept1,
    });
  };

  const accept1 = async () => {
    await procesoPercepcionesAGIP({
      proceso,
      empresaElegida,
      usuario: state.usuario.usuario,
    }).then((data) => {
      let elem = document.getElementById("generarProceso");
      elem.click();
    });
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Proceso de Impresión",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const renderHeaderProceso = () => {
    return (
      <div>
        <Tag
          value={
            empresaElegida && empresas && empresas.length > 0
              ? "Percepciones A.G.I.P. " + empresaElegida.nombre
              : null
          }
        ></Tag>
      </div>
    );
  };

  const renderFooterProceso = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarProceso}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
          autoFocus
        >
          Aceptar
        </ButtonMui>

        <ButtonMui
          onClick={onHideProceso}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const fechaTemplate = (rowData) => {
    return <Fragment>{formatDate(rowData.fecha)}</Fragment>;
  };

  const anuladoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.anulado}></Checkbox>
      </Fragment>
    );
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  function formatDateReves(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return year + month + day;
  }

  function formatDateIso(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[0], thisDate[1], thisDate[2]].join("");
    var newTime = [thisTime[0], thisTime[1]].join(":");
    return newDate;
  }

  const generar = async () => {
    const formatDateArg = (dateStr) => {
      const [year, month, day] = dateStr.split("-");
      return `${day}/${month}/${year}`;
    };

    // Función para formatear números con padding y separador decimal coma
    const formatNumberArg = (num, totalLength, decimalLength) => {
      // Usamos toFixed para controlar decimales, luego replace para la coma

      let formatted = Number(num).toFixed(decimalLength).replace(".", ",");
      // Aseguramos el padding izquierdo con ceros hasta la longitud total especificada
      while (formatted.length < totalLength) {
        // +1 por la coma
        formatted = "0" + formatted;
      }
      // A veces el length del formato VB6 incluye la coma, hay que ajustar
      // Para los casos como "0000000000000.00" que es length 16:
      if (totalLength === 16) {
        while (formatted.length < 16) formatted = "0" + formatted;
      }

      return formatted;
    };

    // Función para padding derecho (espacios)
    const padRight = (str, length) => {
      return String(str).padEnd(length, " ");
    };

    // Función para padding izquierdo (ceros)
    const padLeft = (str, length) => {
      return String(str).padStart(length, "0");
    };

    // Función para emular IIf (Immediate If)
    const iif = (condition, trueVal, falseVal) => {
      return condition ? trueVal : falseVal;
    };

    if (!procesos || procesos.length === 0) {
      return;
    }

    const doc = new jsPDF();

    /*
    var blob = new Blob([], { type: "text/plain;charset=utf-8" });
    for (var i = 0; i < 10; i++) {
      blob = new Blob([blob, " " + i], { type: "text/plain" });
    }

    saveAs(blob, "hello_world.txt");

    return;
    */

    let hoy = new Date();

    let fechaDia = hoy.getDate();
    let fechaMes = hoy.getMonth() + 1;
    let fechaAnio = hoy.getFullYear();
    let nombreMes = "";

    if (fechaMes === 1) {
      nombreMes = "Enero";
    }
    if (fechaMes === 2) {
      nombreMes = "Febrero";
    }
    if (fechaMes === 3) {
      nombreMes = "Marzo";
    }
    if (fechaMes === 4) {
      nombreMes = "Abril";
    }
    if (fechaMes === 5) {
      nombreMes = "Mayo";
    }
    if (fechaMes === 6) {
      nombreMes = "Junio";
    }
    if (fechaMes === 7) {
      nombreMes = "Julio";
    }
    if (fechaMes === 8) {
      nombreMes = "Agosto";
    }
    if (fechaMes === 9) {
      nombreMes = "Septiembre";
    }
    if (fechaMes === 10) {
      nombreMes = "Octubre";
    }
    if (fechaMes === 11) {
      nombreMes = "Noviembre";
    }
    if (fechaMes === 12) {
      nombreMes = "Diciembre";
    }

    let empresa = empresas.find((item) => item.id === empresaElegida.id);

    let cuitEmpresa = null;
    if (empresa.cuit !== null) {
      cuitEmpresa =
        empresa.cuit.substring(0, 2) +
        empresa.cuit.substring(3, 11) +
        empresa.cuit.substring(12, 13);
    }

    let procesoMes = proceso.periodo.substring(0, 2);
    let procesoAnio = "20" + proceso.periodo.substring(3, 5);

    let blobArchivo = new Blob([], {
      type: "text/plain;charset=utf-8",
    });

    let blobArchivoNC = new Blob([], {
      type: "text/plain;charset=utf-8",
    });

    let xCodDoc = null;
    let xCodComp = null;
    let tipoComp = null;

    for (var i = 0; i < procesos.length; i++) {
      let outputLine = "";
      let cuit = procesos[i].cuit;
      cuit = cuit.replaceAll("-", "");
      tipoComp = null;

      // En JS no escribimos a Print #1 o Print #2 directamente,
      // sino que retornamos la cadena para su uso posterior (e.g., descarga de archivo)

      if (
        procesos[i].id_comprobanteafip === 1 ||
        procesos[i].id_comprobanteafip === 6 ||
        procesos[i].id_comprobanteafip === 11 ||
        procesos[i].id_comprobanteafip === 51 ||
        procesos[i].id_comprobanteafip === 201 ||
        procesos[i].id_comprobanteafip === 206 ||
        procesos[i].id_comprobanteafip === 211
      ) {
        tipoComp = "01";
      }

      if (
        procesos[i].id_comprobanteafip === 2 ||
        procesos[i].id_comprobanteafip === 7 ||
        procesos[i].id_comprobanteafip === 12 ||
        procesos[i].id_comprobanteafip === 52 ||
        procesos[i].id_comprobanteafip === 202 ||
        procesos[i].id_comprobanteafip === 207 ||
        procesos[i].id_comprobanteafip === 212
      ) {
        tipoComp = "09";
      }

      if (tipoComp === "01" || tipoComp === "09") {
        const baseImponible =
          procesos[i].total -
          procesos[i].iva -
          procesos[i].percarba -
          procesos[i].percagip;

        const retencionCalculada =
          (baseImponible * procesos[i].tasapercagip) / 100;

        outputLine =
          "2" +
          "029" +
          formatDateArg(procesos[i].fecha) +
          tipoComp +
          procesos[i].tipo +
          padLeft(procesos[i].numero, 16) +
          formatDateArg(procesos[i].fecha) +
          formatNumberArg(procesos[i].total, 16, 2) + // total length 16
          padRight("", 16) + // Space(16)
          "3" +
          cuit +
          "3" +
          cuit +
          iif(
            procesos[i].id_tipocontribuyente === 6,
            "1",
            iif(
              procesos[i].id_tipocontribuyente === 2,
              "3",
              iif(procesos[i].id_tipocontribuyente === 3, "4", "0")
            )
          ) +
          padRight(procesos[i].nombre_titular.substring(0, 30).trim(), 30) +
          formatNumberArg(procesos[i].percagip, 16, 2) +
          formatNumberArg(procesos[i].iva, 16, 2) +
          formatNumberArg(baseImponible, 16, 2) +
          formatNumberArg(procesos[i].tasapercagip, 5, 2) + // "00.00" length 5
          formatNumberArg(retencionCalculada, 16, 2) +
          formatNumberArg(procesos[i].percagip, 16, 2) +
          " " +
          padRight("", 10);

        blobArchivo = new Blob([blobArchivo, outputLine + "\n"], {
          type: "text/plain;charset=utf-8",
        });
      }

      if (
        procesos[i].id_comprobanteafip === 3 ||
        procesos[i].id_comprobanteafip === 8 ||
        procesos[i].id_comprobanteafip === 13 ||
        procesos[i].id_comprobanteafip === 53 ||
        procesos[i].id_comprobanteafip === 203 ||
        procesos[i].id_comprobanteafip === 208 ||
        procesos[i].id_comprobanteafip === 213
      ) {
        const absTotal = Math.abs(procesos[i].total);
        const retencionIB = Math.abs(
          (procesos[i].total * procesos[i].tasapercagip) / 100
        );

        let facturanc = null;
        let tiponc = null;
        let numeronc = null;
        if (procesos[i].comprobantenc.comprobante.substring(0, 1) === "F") {
          facturanc = "01";
        } else {
          facturanc = "02";
        }
        tiponc = procesos[i].comprobantenc.tipo;
        numeronc = procesos[i].comprobantenc.numero;

        outputLine =
          "2" +
          padLeft(procesos[i].numero, 12) +
          formatDateArg(procesos[i].fecha) +
          formatNumberArg(absTotal, 16, 2) +
          padRight("", 16) +
          facturanc +
          tiponc +
          padLeft(numeronc, 16) +
          cuit +
          "029" +
          formatDateArg(procesos[i].fecha) +
          formatNumberArg(retencionIB, 16, 2) +
          formatNumberArg(Math.abs(procesos[i].tasapercagip), 5, 2);

        blobArchivoNC = new Blob([blobArchivoNC, outputLine + "\n"], {
          type: "text/plain;charset=utf-8",
        });
      }

      //Print #1, !numerodocumento; Mid(!fecha, 1, 10); "F"; !tipo; ; Format(!sucursal, "0000"); Format(!numero, "00000000"); Replace(Format(!subtotal, "000000000.00"), ".", ","); Replace(Format(!ib, "00000000.00"), ".", ","); "A"
    }

    saveAs(
      blobArchivo,
      "ARCIBA-" + cuitEmpresa + "-" + procesoAnio + procesoMes + "FC" + ".txt"
    );
    saveAs(
      blobArchivoNC,
      "ARCIBA-" + cuitEmpresa + "-" + procesoAnio + procesoMes + "NC" + ".txt"
    );
  };

  //console.log(empresas);
  //console.log(serviciosFinalizadosExcel);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      <ConfirmDialog />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderProceso()}
            visible={visibleProceso}
            closable={false}
            footer={renderFooterProceso()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={4}>
                <label htmlFor="periodo">Período</label>
                <InputMask
                  id="periodo"
                  mask="99/99"
                  value={proceso ? proceso.periodo : null}
                  placeholder="99/99"
                  size={4}
                  onChange={(e) =>
                    guardarProceso({
                      ...proceso,
                      periodo: e.value,
                    })
                  }
                  style={{ marginLeft: "0.7vw", marginTop: "0.4vw" }}
                ></InputMask>
              </Grid>
              <button
                id="generarProceso"
                type="button"
                onClick={(e) => {
                  generar();
                }}
                style={{ display: "none" }}
              >
                Imprimir Facturas
              </button>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}

      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
